import * as St from './ColorsList.styles';

import type { ColorItemData, ColorItemProps } from '~organisms/ColorItem';
import ColorItem from '~organisms/ColorItem';

type Color = ColorItemData['color'];
type ColorId = Color['productId'];

type ColorsListData = {
  colors: Color[];
};

type ColorsListProps = Omit<
  ColorItemProps,
  'data' | 'onSelect' | 'isSelected'
> &
  React.PropsWithChildren<{
    data: ColorsListData;
    aria?: React.AriaAttributes;
    selectedColorId?: ColorId;
    onSelect: (productId: ColorId) => void;
    ItemComponent?: typeof ColorItem;
  }>;

const ColorsList = ({
  children,
  data,
  aria = {},
  selectedColorId,
  onSelect,
  ItemComponent = ColorItem,
  ...props
}: ColorsListProps) => (
  <St.Container role="list" {...aria}>
    {data.colors.map((color) => (
      <ItemComponent
        {...props}
        isSelected={selectedColorId === color.productId}
        key={color.productId}
        data={{ color }}
        onSelect={() => onSelect(color.productId)}
      />
    ))}
    {children}
  </St.Container>
);

export default ColorsList;
